import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { AppSettingService } from 'src/services/app-setting/app-setting.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(private meta: Meta, public appSettingService: AppSettingService) { }

  ngOnInit(): void {
    // Initialisation des métadonnées
    this.meta.addTag({ name: 'description', content: "Page de contact de la BSTP Guinée avec nos coordonnées et informations" });
    this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, Contact BSTP, Adresse BSTP' });
    this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });
    
    // Initialisation des animations AOS
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  }

}
